import React from 'react';
import Store from "../store/Store";
import {useParams} from "react-router-dom";
import {Card, Col, Row} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import useTableTask from '../hooks/useTableTask';
import TaskCard from '../components/TaskCard';
import TaskFilterBar from '../components/TaskFilterBar';
import useTaskFilter from '../hooks/useTaskFilter';
import '../css/mytask.css';


export default (props) => {
    let params = useParams();
    let {tasks, tables, user} = Store.getState();
    // const [isDoneFilter,setIsDoneFilter] = useState(false);
    // const [order,setOrder] = useState(0);

    const {
        table, tasksByTable, relatedParcels, redirectToTable, tableName, navigate, isNebihSendable, statusIcons, isCompleted, taskStates, toggleTaskState, toggleAllTasks, allTasksOpen
    } = useTableTask();  // A hook adatainak kinyerése

    const { 
        searchKey, setSearchKey, isDoneFilter, setIsDoneFilter, order, setOrder, filteredTasks
    } = useTaskFilter(tasks, user, user.id);


    
    // for (let i = 0; i < tasks.length; i++) {
    //     let task = tasks[i];
    //     if(task.sub_tasks.find(subtask=>subtask.user_id && subtask.user_id === user.id)) {
    //         filteredTasks = [...filteredTasks,task];
    //     }
    // }

    // az adott felhasználóhoz tartozó feladatok
    let userTasks = tasks.filter(task =>
        task.sub_tasks.some(subtask => subtask.user_id === user.id)
    );

    
    const renderTask = (task) => {
        return (
            <Col key={'task_'+task.id} xs={12} md={6} lg={4}>
                <Card border="light" className="mb-2" onClick={(e)=>{redirectToTable(e,"/edit-task/"+task.guid)}}>
                    <Card.Header><strong><FontAwesomeIcon className="icon" icon={'seedling'} /> {task.name}</strong>{task.completed_at ? <FontAwesomeIcon className="icon" style={{float:'right'}} icon={faCircleCheck} />:<></>}</Card.Header>
                    <Card.Body>
                            <Row>
                                <Col><span><strong>Táblacsoport</strong></span></Col>
                                <Col><span><button className={"btn-link"} onClick={(e)=>{redirectToTable(e,"/task/"+task.table_id)}}>{tableName(task.table_id)}</button></span></Col>
                            </Row>
                            <Row>
                                <Col><span><strong>Aratási év</strong></span></Col>
                                <Col><span>{task.harvest_year_name}</span></Col>
                            </Row>
                            <Row>
                                <Col><span><strong>Terület</strong></span></Col>
                                <Col><span>{task.task_area}</span></Col>
                            </Row>
                            <Row>
                                <Col><span><strong>Költség/ha</strong></span></Col>
                                <Col><span>{task.task_cost}</span></Col>
                            </Row>
                            <Row>
                                <Col><span><strong>Kezdés</strong></span></Col>
                                <Col><span>{task.started_at}</span></Col>
                            </Row>
                            {task.completed_at && <Row>
                                <Col><span><strong>Befejezés</strong></span></Col>
                                <Col><span>{task.completed_at}</span></Col>
                            </Row>}
                    </Card.Body>
                </Card>
            </Col>
        )
    }

    const renderHead = ()=>{
        return (<div className={"page-head my-2 d-flex"}>
            <strong>{table.name}</strong>
            <div>
                {/* <Link to={"/"} className={"btn button"}>{"< Vissza"} </Link> */}
                <button onClick={()=>{goBack()}} className={"btn button"}>{"< Vissza"} </button>
            </div>
        </div>);
    }
    
    const goBack = ()=> {
        navigate(-1);
      }

    const onIsDone = (tasks) => {
        if (isDoneFilter === true) {
            return tasks.filter(task => !task.completed_at);
        } else {
            return tasks;
        }
    }
    
    const onOrder = (tasks)=>{
        let sorted = null;
        if(order == 1) {
            sorted = tasks.sort((a, b) => (a.started_at > b.started_at) ? 1 : ((b.started_at > a.started_at) ? -1 : 0));
        }else{
            sorted= tasks.sort((a, b) => (b.started_at > a.started_at) ? 1 : ((a.started_at > b.started_at) ? -1 : 0));
        }
        return sorted;
    }

    if (table) {
        if (tasksByTable && tasksByTable.length) {
            return (
                <div>
                    {renderHead()}
                    <Row>
                        {tasksByTable && tasksByTable.length && tasksByTable.map((task) => {
                            return renderTask(task)
                        })}
                    </Row>
                </div>
            )
        } else {
            return (
                <div>
                    {renderHead()}
                    Jelenleg nincs faladat ehez a táblacsoporthoz
                </div>
            )
        }
    }else{
        return (
            <>
                <div className={"page-head mt-2 mb-3 d-flex"}>
                    <h3 className="title"><strong>{!table ? "Saját feladataim ("+filteredTasks.length+")" : "Táblacsoport" }</strong></h3>
                    <div>
                        {/* <Link to={"/"} className={"btn button"}>{"< Vissza"} </Link> */}
                        <button onClick={()=>{goBack()}} className={"btn button"}>{"< Vissza"} </button>
                    </div>
                </div>
                <TaskFilterBar
                    searchKey={searchKey}
                    setSearchKey={setSearchKey}
                    order={order}
                    setOrder={setOrder}
                    isDoneFilter={isDoneFilter}
                    setIsDoneFilter={setIsDoneFilter}
                    />

                <Row>
                    {filteredTasks.map((task) => (
                    <TaskCard
                        key={'task_' + task.id}
                        task={task}
                        isNebihSendable={isNebihSendable}
                        statusIcons={statusIcons}
                        isCompleted={isCompleted}
                        tableName={tableName}
                        redirectToTable={redirectToTable}
                        isOpen={taskStates[task.id] !== false}
                        toggleTaskState={toggleTaskState}
                    />
                    ))}
                    {!filteredTasks.length && <strong>Nincs a keresési feltételeknek megfelelő feladat!</strong>}
                </Row>
            </>
        )
    }

}